import { IssuesTableComponent } from '@components/pages/service-pages/issues/issues-table/issues-table.component';
import { UnderConstructionComponent } from '@components/shared/under-construction/under-construction.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FlatTypeTableComponent } from './flat-type-table/flat-type-table.component';

@Component({
  selector: 'app-flat-type',
  imports: [UnderConstructionComponent, CommonModule, IssuesTableComponent, TranslateModule, ButtonModule, FlatTypeTableComponent],
  templateUrl: './flat-type.component.html'
})
export class FlatTypeComponent {
  constructor(private readonly router: Router) {}

  /**
   * Navigate to create new flat type
   */
  onCreateClick(): void {
    this.router.navigate(['/issues/new']);
  }
}
